<template>
  <div class="text-right font-28">
    <span v-if="showLabel && showLabel.length > 0">
      {{ showStringOrArray(showLabel) }}
    </span>
    <span v-else-if="value && value.length > 0">
      {{ getShowLabel(value, treeData, keyField, labelField) }}
    </span>
    <span v-else class="cor-CC">
      {{ placeholder }}
    </span>
    <van-icon v-if="!value && !showLabel" name="arrow" color="#8c8c8c"/>
  </div>
</template>
<script>
export default {
  name: "index",
  props: {
    value: {},
    placeholder: {
      type: String,
      default: ''
    },
    treeData: {
      type: Array,
      default: () => []
    },
    keyField: {
      type: String,
      default: 'id'
    },
    labelField: {
      type: String,
      default: 'label'
    },
    showLabel: {},
  },
  methods: {
    getShowLabel(value, treeData, keyField, labelField) {
      if (this.treeData && this.treeData.length > 0) { // treeData有值则递归获取label
        const str = this._getShowLabel(treeData, value);
        return str;
      } else {// treeData无值则直接返回value
        if (typeof value === 'string') {
          if (value.indexOf(',') > -1) {
            return value.split(',')[1] + (value.split(',')[2] ? (',' + value.split(',')[2]) : '')
          } else {
            return value
          }
        }
      }
    },
    _getShowLabel(treeList, value) {
      let newStr = '';
      const processTree = (originalItems) => {
        originalItems.forEach((item, i) => {
          const newItem = {...item}; // 创建一个新对象来避免修改原始数据
          if (newItem[this.keyField] == value) {
            newStr = newItem[this.labelField];
          }
          if (newItem.children && newItem.children.length > 0) {
            newItem.children = processTree(newItem.children); // 递归调用并更新 children
          }
        });
        return newStr; // 返回新数组
      };
      return processTree(treeList); // 启动递归处理并返回新的树列表
    },
    // 数组或字符串`
    showStringOrArray(data) {
      if (Array.isArray(data)) {
        // 如果data是一个数组，则使用join方法将其拼接为一个字符串
        return data.join(' ');
      } else if (typeof data === 'string' || data instanceof String) {
        // 如果data是一个字符串，则直接返回该字符串
        return data;
      } else {
        // 如果data既不是数组也不是字符串，则返回一个错误或相应的提示
        return data;
      }
    }
  },
}
</script>
